import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import DBNIEComponent from '../components/dbnie.component';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectDbnieQueryItems } from '../../../../../redux/dbn-cloud/dbnie/selector';
import { dbnie } from '../../../../../redux/dbn-cloud/dbnie/action';


const DBNIE = () => { 
  const dispatch = useAppDispatch()
  const dbnieQuery = useSelector(selectDbnieQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [ selectDbnie, setSelectDbnie] = useState<any>([])
  
  const fetchDbnieQueryById= ()=>{
    dispatch(dbnie.query({
      url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnie/query`,
      entity:'dbnie',
      jsonData:{
        Context:{},
        Records: [
          {
            Id: 0
          }
        ]
    }})).then(()=>{
      setIsQuery(true)
    })
  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectDbnie({ ...selectDbnie, [field]: event })
  }

  useEffect(
    () => {
        fetchDbnieQueryById()
      setIsLoading(false)
    },[]
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectDbnie(dbnieQuery?.result?.items)
      }
    },[isQuery]
  ) 

  const handleFormSubmit  = async (event: any) => {
    event.preventDefault(); 
    await dispatch(dbnie.resetAction({ actionType: 'update' }))
    await dispatch(dbnie.update({
      url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnie`,
      entity:'dbnie',
      jsonData:{
        Context:{},
        Records: [
            selectDbnie
        ]
    }}))
  }

  return (
    <>
    {isLoading ? <PageLoader /> : 
      <DBNIEComponent 
      handleInnerbasicFormChange={handleInnerbasicFormChange}
      selectDbnie={selectDbnie}
      handleFormSubmit={handleFormSubmit}
      /> 
    } 
    </>
  )
};
   
export default DBNIE;